import React from "react";
import { Facebook, Instagram, Twitter, Youtube, ArrowUp } from "lucide-react";

const Footer: React.FC = () => {
  // Page ke top par scroll karne ka function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="w-full font-sans flex flex-col ">
      
      {/* ========================================= */}
      {/* LAYER 1: NEWSLETTER SECTION (White/Light) */}
      {/* ========================================= */}
      <div className="bg-[#fcfdfa] py-16 px-4 text-center border-t border-gray-100">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-black text-[#2e3d2f] uppercase tracking-widest mb-4">
            Join Our Herbal Family.
          </h2>
          <p className="text-gray-500 text-sm md:text-base mb-8 font-medium">
            Stay up-to-date with our new arrivals, upcoming events, seasonal specials, and wellness secrets.
          </p>
          
          <form className="flex flex-col sm:flex-row max-w-xl mx-auto gap-2">
            <input 
              type="email" 
              placeholder="Enter your email address" 
              className="flex-grow bg-gray-100/80 text-gray-800 px-6 py-4 outline-none border border-transparent focus:border-green-600 font-medium transition-colors"
              required
            />
            <button 
              type="submit" 
              className="bg-[#2e3d2f] hover:bg-[#1a241a] text-white px-8 py-4 font-bold uppercase tracking-widest transition-colors shadow-lg"
            >
              Sign Me Up!
            </button>
          </form>
        </div>
      </div>

      {/* ========================================= */}
      {/* LAYER 2: DARK LINKS & SOCIALS (Dark Gray) */}
      {/* ========================================= */}
      <div className="bg-[#1b1f1a] py-16 px-4 relative text-center">
        
        {/* Scroll to Top Button (Floating on dark section like in reference) */}
        <button 
            onClick={scrollToTop}
            className="absolute top-6 right-6 md:right-10 border-2 border-gray-600 text-gray-400 p-2 hover:border-white hover:text-white transition-all"
            aria-label="Scroll to top"
        >
            <ArrowUp size={20} />
        </button>

        {/* Social Icons inside Green Circles */}
        <div className="flex justify-center gap-4 mb-10">
          <a href="https://www.facebook.com/profile.php?id=61582206357904" className="w-12 h-12 rounded-full bg-[#4a7c36] text-white flex items-center justify-center hover:bg-green-500 hover:-translate-y-1 transition-all shadow-lg">
            <Facebook size={20} />
          </a>
          <a href="#" className="w-12 h-12 rounded-full bg-[#4a7c36] text-white flex items-center justify-center hover:bg-green-500 hover:-translate-y-1 transition-all shadow-lg">
            <Instagram size={20} />
          </a>
          <a href="#" className="w-12 h-12 rounded-full bg-[#4a7c36] text-white flex items-center justify-center hover:bg-green-500 hover:-translate-y-1 transition-all shadow-lg">
            <Youtube size={20} />
          </a>
          <a href="#" className="w-12 h-12 rounded-full bg-[#4a7c36] text-white flex items-center justify-center hover:bg-green-500 hover:-translate-y-1 transition-all shadow-lg">
            <Twitter size={20} />
          </a>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-3 text-white text-xs md:text-sm font-bold uppercase tracking-widest">
          <a href="/" className="hover:text-[#6ba154] transition-colors">Home</a>
          <span className="text-gray-600 hidden sm:inline">|</span>
          <a href="/all-products" className="hover:text-[#6ba154] transition-colors">Shop All Herbs</a>
          <span className="text-gray-600 hidden sm:inline">|</span>
          <a href="/blog" className="hover:text-[#6ba154] transition-colors">Ayurveda Blog</a>
          <span className="text-gray-600 hidden sm:inline">|</span>
          <a href="/about" className="hover:text-[#6ba154] transition-colors">About Us</a>
          <span className="text-gray-600 hidden sm:inline">|</span>
          <a href="/contact-us" className="hover:text-[#6ba154] transition-colors">Contact</a>
        </div>
        
        {/* Extra Footer Links */}
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-gray-400 text-[10px] sm:text-xs mt-6 font-medium uppercase tracking-wider">
            <a href="/privacy" className="hover:text-white transition-colors">Privacy Policy</a>
            <span className="text-gray-700">|</span>
            <a href="/term&condition" className="hover:text-white transition-colors">Terms of Service</a>
            <span className="text-gray-700">|</span>
            <a href="#" className="hover:text-white transition-colors">Refund Policy</a>
        </div>

      </div>

      {/* ========================================= */}
      {/* LAYER 3: GREEN BOTTOM BAR (Copyright)     */}
      {/* ========================================= */}
      <div className="bg-[#5c8a3c] py-6 px-4 text-center text-white">
        <p className="text-xs md:text-sm font-bold tracking-widest uppercase mb-3 text-white/90">
          HEALTHY, 100% NATURAL AYURVEDIC PRODUCTS, CRAFTED WITH ♥ IN INDIA
        </p>
        
        <div className="flex flex-col items-center justify-center gap-1 text-[11px] md:text-xs font-medium text-white/80">
            <p>
                © 2026 AyushVatika Pvt Ltd. All rights reserved.
            </p>
            <p className="mt-1">
                Designed & Developed by <a href="https://nadezhda.in" target="_blank" rel="noopener noreferrer" className="font-black text-purple-900 hover:text-orange-600 underline decoration-green-300 underline-offset-2 transition-colors">NADEZHDA VENTURE PRIVATE LIMITED</a>
            </p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;